import React, { useEffect } from 'react'
import { DateField } from '@/ui/form/controls/DateField'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { useRaportForm } from '../../context/RaportFormContext'
import Options from './stages/Options'

const SettingsInformationCard = () => {
  const { data, setData } = useRaportForm()
  const { t } = useLocalize()

  useEffect(() => {
    setData((previous: Record<string, unknown>) => ({
      settingsDate: new Date().toLocaleDateString('sv-SE'),
      ...previous,
    }))
  }, [])

  return (
    <div className="tw-flex-1 tw-space-y-4 tw-overflow-auto tw-p-4 tw-pr-8">
      <DateField
        label={t('printout.settingsInformationCardDate')}
        helper={t('printout.settingsInformationCardHint')}
        value={data?.settingsDate ?? new Date().toLocaleDateString('sv-SE')}
        clearable={false}
        setValue={(settingsDate) =>
          settingsDate && setData({ ...data, settingsDate })
        }
      />
      <Options data={data} setData={setData} separateFilesOnly />
    </div>
  )
}

export default SettingsInformationCard
